"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./router'));
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/router-deprecated/index.js
 ** module id = 440
 ** module chunks = 0
 **/